import { MapBoxMode, MapData } from './../../../base/shared/map-box-map/map-box-map.component';
import {
  ClientDTO,
  FilterDTO,
  FilterOperator,
  SortDirection,
  ZoneClient,
  ZoneDamageClient,
  ZoneDamageDTO,
  ZoneDamageState,
  ZoneDeviceClient,
  ZoneDeviceDTO,
  ZoneDTO,
} from '../../../base/models/models.swagger.generated';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DropDownConstantsFactory } from '../../../base/shared/syncfusion/dropdown-constants-factory';
import { EnumTranslationService } from '../../../base/services/enum-translation.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncImageComponent } from '../../../base/shared/async-image/async-image.component';
import { AppErrorMessagesComponent } from '../../../base/error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ZoneDamageEditFormGroup } from './zone-damage-edit-form.type';
import { MapBoxMapComponent } from 'src/app/base/shared/map-box-map/map-box-map.component';

@Component({
    selector: 'app-zone-damage-edit-form',
    templateUrl: './zone-damage-edit-form.component.html',
    styleUrls: ['./zone-damage-edit-form.component.scss'],
    imports: [ReactiveFormsModule, DropDownListModule, AppErrorMessagesComponent, MapBoxMapComponent, AsyncImageComponent, TranslateModule]
})
export class ZoneDamageEditFormComponent implements OnInit, OnDestroy {

  @Input() public zoneDamageEditForm: ZoneDamageEditFormGroup;
  @Input() public client: ClientDTO;
  @Input() public damage: ZoneDamageDTO;

  public get mapData(): MapData {
    return {
      mode: MapBoxMode.PositionMode,
      data: this.zoneDamageEditForm.controls.position.value
    };
  }

  public set mapData(value: MapData) {
    this.zoneDamageEditForm.controls.position.setValue(value.data);
  }

  public deviceList = [];
  public allDevices: ZoneDeviceDTO[] = [];
  public zoneList = [];
  public allZones: ZoneDTO[] = [];
  public dropdownSettings = {text: 'name', value: 'id'};

  public ZoneDamageState = ZoneDamageState;
  public enumDropdownSettings = DropDownConstantsFactory.createEnumDropdownSettings();
  public states = this.enumTranslationService.translateEnum(ZoneDamageState, 'i18n.domain.zone-damage.state.', true);

  MapBoxMode = MapBoxMode;

  private unsubscribe$ = new Subject<void>();

  constructor(private zoneDeviceClient: ZoneDeviceClient,
              private zoneDamageClient: ZoneDamageClient,
              private enumTranslationService: EnumTranslationService,
              private zoneClient: ZoneClient) {
  }

  public ngOnInit(): void {
    this.zoneDamageClient.getDamage(this.damage.id)
      .subscribe(damage => {
        this.damage = damage;
      });

    this.zoneDeviceClient.searchDevices(this.client.id, null, 0, 0, 'Id', SortDirection.Ascending)
      .subscribe(devices => {
        this.allDevices = devices.items;
        this.deviceList = devices.items.map(d => ({name: d.name, id: d.id}));
      });

    const filter = new FilterDTO({isComplex: false, field: 'IsGroupingElement', operator: FilterOperator.Equal, value: 'false'});
    this.zoneClient.searchZones(this.client.id, [filter], 0, 0, 'Id', SortDirection.Ascending)
      .subscribe(zones => {
        this.allZones = zones.items;
        this.zoneList = zones.items.map(d => ({name: d.name, id: d.id}));
      });


    this.zoneDamageEditForm.controls.zone.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe(zoneId => {
        if (this.allDevices.length) {
          if (zoneId) {
            this.deviceList = this.allDevices
              .filter(d => d.zone && d.zone.id === zoneId)
              .map(d => ({name: d.name, id: d.id}));

            if (this.deviceList.length === 1) {
              this.zoneDamageEditForm.controls.deviceId.setValue(this.deviceList[0].id);
            }
          } else  {
            this.deviceList = this.allDevices.map(d => ({name: d.name, id: d.id}));
          }
        }
      });

    this.zoneDamageEditForm.controls.deviceId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe(deviceId => {
        if (deviceId) {
          if (!this.zoneDamageEditForm.controls.zone.value) {
            const device = this.allDevices.find(d => d.id === deviceId);
            const zone = this.allZones.find(z => z.id === device.zone?.id);
            this.zoneDamageEditForm.controls.zone.setValue(zone?.id);
          }
        }
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public getImageRequest(id: number, imageId: string): any {
    return this.zoneDamageClient.getDamageImage(id, imageId);
  }
}
